export enum InvoiceTypeEnum {
    InvoiceOpen = 'InvoiceOpen',
    InvoiceHistory = 'InvoiceHistory'
}